import React from "react";
import "./ErrorModal.scss";
import crossIcon from "../../assets/icons/ErronIconsClose.svg";
import CloseBtn from "../../assets/icons/ClosebuttonModal.svg";

function ErrorModal({setModalOpen, handleNavigation, desc, btnText, info = false}) {
  const [isClosing, setIsClosing] = React.useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      if (setModalOpen) setModalOpen();
      if (handleNavigation) handleNavigation();
    }, 400);
  };

  return (
    <div
      className="error_modal_overlay"
      onClick={handleClose}
    >
      <div
        className={`errorModalWrapper errorPopupContainer ${info ? "info" : ""} ${isClosing ? "closing" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popupIcon">
          <img
            src={crossIcon}
            alt="error"
          />
        </div>

        <div className="titleContent">
          <h1>{info ? "Information" : "Error"}</h1>
          <p>{typeof desc === "string" ? desc : "An unexpected error occurred."}</p>
        </div>

        <div className="actionArea">
          <button
            className="error_modal_close_btn"
            onClick={handleClose}
          >
            {btnText || "Close"}
          </button>
          {/* <img
            src={CloseBtn}
            alt="Close"
            onClick={handleClose}
            className="closeBtnSect"
          /> */}
        </div>
      </div>
    </div>
  );
}

export default ErrorModal;
